var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-select",
    _vm._g(
      _vm._b(
        {
          directives: [
            {
              name: "element-value",
              rawName: "v-element-value",
              value: _vm.fusionInputCheckValue,
              expression: "fusionInputCheckValue",
            },
            {
              name: "fusioninputcheck",
              rawName: "v-fusioninputcheck",
              value: _vm.fusionInputCheckBinding,
              expression: "fusionInputCheckBinding",
            },
          ],
          staticClass: "hkl-select",
          class: {
            "hkl-select_right-align": _vm.align === "right",
            "hkl-select_single-taggable-input": _vm.singleTaggableInput,
            "hkl-select_multiple": _vm.isMultipleSelect,
            "hkl-select_multiple-has-value": _vm.isMultipleSelectNotEmpty,
            "hkl-select_multiple-search-empty": _vm.isMultipleSearchEmpty,
          },
          attrs: {
            value: _vm.selectValue,
            optionFilterProp: "title",
            showArrow: _vm.showArrow,
            getPopupContainer: _vm.resolvedGetPopupContainer,
            dropdownClassName: _vm.mergedDropdownClassName,
            dropdownStyle: _vm.mergedDropdownStyle,
          },
          on: {
            change: _vm.onSelectChange,
            select: _vm.onSelect,
            search: _vm.onSelectSearch,
            focus: _vm.onSelectFocus,
            blur: _vm.onSelectBlur,
            dropdownVisibleChange: _vm.onDropdownVisibleChange,
          },
          nativeOn: {
            "!keydown": function ($event) {
              return _vm.onSelectKeydownCapture.apply(null, arguments)
            },
          },
        },
        "a-select",
        _vm.selectAttrs,
        false
      ),
      _vm.selectListeners
    ),
    [
      _vm._l(_vm.options, function (option, index) {
        return [
          _vm.isOptionGroup(option) && option.options.length
            ? _c(
                "a-select-opt-group",
                {
                  key: "group-" + index,
                  attrs: { label: option.name, title: option.name },
                },
                _vm._l(option.options, function (o, i) {
                  return _c(
                    "a-select-option",
                    {
                      key: index + "-" + i,
                      class: {
                        "hkl-select__tag-option":
                          _vm.isSingleTaggableInputTagOption(o),
                        "hkl-select__display-only-option":
                          _vm.isDisplayOnlyOption(o),
                      },
                      attrs: {
                        value: _vm.getOptionValue(o),
                        label: _vm.getOptionSelectedLabel(o),
                        title: _vm.getOptionTitle(o),
                        disabled: _vm.isOptionDisabled(o),
                      },
                    },
                    [
                      _vm.getOptionHint(o)
                        ? _c(
                            "span",
                            { staticClass: "hkl-select__option-with-hint" },
                            [
                              _c(
                                "span",
                                { staticClass: "hkl-select__option-label" },
                                [_vm._v(_vm._s(_vm.getOptionTitle(o)))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "hkl-select__option-hint" },
                                [_vm._v(_vm._s(_vm.getOptionHint(o)))]
                              ),
                            ]
                          )
                        : _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.getOptionTitle(o)),
                            },
                          }),
                    ]
                  )
                }),
                1
              )
            : !_vm.isOptionGroup(option)
            ? _c(
                "a-select-option",
                {
                  key: "option-" + index,
                  class: {
                    "hkl-select__tag-option":
                      _vm.isSingleTaggableInputTagOption(option),
                    "hkl-select__display-only-option":
                      _vm.isDisplayOnlyOption(option),
                  },
                  attrs: {
                    value: _vm.getOptionValue(option),
                    label: _vm.getOptionSelectedLabel(option),
                    title: _vm.getOptionTitle(option),
                    disabled: _vm.isOptionDisabled(option),
                  },
                },
                [
                  _vm.getOptionHint(option)
                    ? _c(
                        "span",
                        { staticClass: "hkl-select__option-with-hint" },
                        [
                          _c(
                            "span",
                            { staticClass: "hkl-select__option-label" },
                            [_vm._v(_vm._s(_vm.getOptionTitle(option)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "hkl-select__option-hint" },
                            [_vm._v(_vm._s(_vm.getOptionHint(option)))]
                          ),
                        ]
                      )
                    : _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.getOptionTitle(option)),
                        },
                      }),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }